import React from 'react'
import { isMobile } from 'react-device-detect';
import { useNavigate  } from "react-router-dom";


function Header(props) {

  const navigate = useNavigate();
  
          


  function clicMoreInfo(props) { 
    var cv = document.getElementById('canvasDiv');
    var more = document.getElementById('MoreInfo');

    
    cv.hidden = true;
    more.hidden = false;
 }


  return (
    <>
     
      <span className="absolute mouse2  border-blue-700 w-full flex justify-center z-10" onMouseDown={() => { clicMoreInfo(props) }} onMouseEnter={() => { }} onMouseLeave={() => { }} >
        {props.userInfo?.id }  HYPERURANIUM
      </span>
    </>
    )
}

export default Header

